import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";
import { Spin } from "antd";

import { rupiahFormat } from "../../../app/helper";
import { validateVoucher } from "../cart.api";
import voucherIcon from "../../../img/voucherIcon.svg";

export default function VoucherSection({ cartId, onApply }) {
  const dispatch = useDispatch();
  const loadingVoucher = useSelector((state) => state.cart.loadingVoucher);
  const [voucherCode, setVoucherCode] = useState("");
  const [voucherError, setVoucherError] = useState("");
  const [voucherDiscount, setVoucherDiscount] = useState(null);

  const handleApplyVoucher = () => {
    if (!voucherCode.trim()) return;
    setVoucherError("");
    setVoucherDiscount(null);
    dispatch(
      validateVoucher({
        cartId,
        voucherNo: voucherCode.trim(),
      }),
    )
      .then(unwrapResult)
      .then((res) => {
        const discount = res?.discountAmount ?? 0;
        setVoucherDiscount(discount);
        onApply?.({ discountAmount: discount, voucherNo: voucherCode.trim() });
      })
      .catch(() => {
        setVoucherError(`Kode voucher ${voucherCode.trim()} tidak valid`);
      });
  };

  const handleClearVoucher = () => {
    setVoucherCode("");
    setVoucherError("");
    setVoucherDiscount(null);
    onApply?.({ discountAmount: 0, voucherNo: "" });
  };

  return (
    <div className="px-4 mb-4 voucher-section">
      <p className="text-bold mb-2">Kode Voucher</p>
      <div className="d-flex align-items-center gap-2">
        <div className="voucher-input-wrap d-flex align-items-center flex-grow-1">
          <img src={voucherIcon} alt="" className="voucher-icon" />
          <input
            className="voucher-input"
            placeholder="Masukkan kode voucher"
            value={voucherCode}
            onChange={(e) => setVoucherCode(e.target.value)}
          />
          {voucherCode && (
            <button
              type="button"
              onClick={handleClearVoucher}
              className="voucher-clear-btn"
            >
              ×
            </button>
          )}
        </div>
        <Spin spinning={loadingVoucher}>
          <button
            className="voucher-btn"
            onClick={handleApplyVoucher}
            disabled={loadingVoucher}
          >
            Pakai
          </button>
        </Spin>
      </div>
      {voucherError && (
        <p
          className="mb-0 mt-1"
          style={{ color: "#CD3438", fontStyle: "italic", fontSize: 12 }}
        >
          {voucherError}
        </p>
      )}
      {voucherDiscount !== null && (
        <p className="mb-0 mt-1" style={{ color: "#28a745", fontSize: 12 }}>
          Kamu mendapat voucher {rupiahFormat(voucherDiscount)}
        </p>
      )}
    </div>
  );
}
